export const environment = {
  production: true,
  whitelistedDomains: ['tecweb-masterdataservice-qa.azurewebsites.net',
    'teccom-backend-userservice-qa.azurewebsites.net', 'teccom-backend-organizationservice-qa.azurewebsites.net'],
  tecWebSiteUrl: 'https://teccom.qa.tecalliance.cloud/newapp',
  masterDataServiceUrl: 'https://tecweb-masterdataservice-qa.azurewebsites.net/Api',
  userServiceUrl: 'https://teccom-backend-userservice-qa.azurewebsites.net/api',
  organizationServiceUrl: 'https://teccom-backend-organizationservice-qa.azurewebsites.net/api',
  enableOrderManagerBeta: true,
  signalRUrl: 'https://tecnotification-qa.azurewebsites.net',
  enableReturnsBeta: true,
  statusPageUrl: 'https://status.tecalliance.net',
  defaultRoute: '/home/dashboard',
  reportAnIssueUrl: 'https://ordersupportweb-qa-frontend.azurewebsites.net',
  orderManagerWikiUrl: 'https://help-ordermanagerportal.tecalliance.net',
  knowledgeDatabaseApiUrl: 'https://h3rlhecxz7.execute-api.eu-central-1.amazonaws.com/qa',
  oktaOptions: {
    clientId: '0oa1rn356wpb9hpSg0x7',
    issuerUri: 'https://login.qa.tecalliance.cloud/oauth2/default',
    redirectUri: `${window.location.origin}/callback`,
    postLogoutRedirectUri: 'https://teccom.qa.tecalliance.cloud/newapp/auth/welcome'
  },
  moduleSubdomains: {
    returns: 'https://returns.',
    tecweb: 'https://teccom.',
    connect: 'https://connectweb.',
    vcTool: 'https://validationcertification.',
    dashboard: 'https://dashboard.',
    mfe: 'https://teccom-portal.'
  },
  currentModule: 'https://validationcertification.qa.tecalliance.cloud',
  showTxml5: true
};
